// French number formats (RG-17, RNF-24), aligned with the mock-up and the reference
// engine. Thousands separator is a non-breaking space (U+00A0); the null euro amount
// renders as "MINUS SIGN space euro" (U+2212). Decimal separator is a comma.

const NBSP = ' ';
const MINUS = '−';

/** Insert a non-breaking thousands separator into an integer string. */
function separerMilliers(entier: string): string {
  return entier.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
}

/** Euro amount, rounded to the unit. Null/undefined renders as the arbitrage dash. */
export function fmtEuros(n: number | null | undefined): string {
  if (n === null || n === undefined) {
    return `${MINUS} €`;
  }
  const arrondi = Math.round(n);
  const signe = arrondi < 0 ? MINUS : '';
  return `${signe}${separerMilliers(Math.abs(arrondi).toString())} €`;
}

/** Amount in thousands of euros with one optional decimal (e.g. "320 k€", "12,5 k€"). */
export function fmtKE(n: number): string {
  const valeur = Math.round(n * 10) / 10;
  const signe = valeur < 0 ? MINUS : '';
  return `${signe}${Math.abs(valeur).toString().replace('.', ',')} k€`;
}

/** Plain integer with a non-breaking thousands separator. */
export function fmtNombre(n: number): string {
  const arrondi = Math.round(n);
  const signe = arrondi < 0 ? MINUS : '';
  return `${signe}${separerMilliers(Math.abs(arrondi).toString())}`;
}

interface OptionsPct {
  readonly decimals?: number;
  readonly signe?: boolean;
}

/** Percentage from a decimal rate (0.031 -> "3,1 %"). */
export function fmtPct(x: number, options: OptionsPct = {}): string {
  const decimals = options.decimals ?? 1;
  const pourcent = x * 100;
  const signe = options.signe ? (pourcent >= 0 ? '+' : MINUS) : pourcent < 0 ? MINUS : '';
  const corps = Math.abs(pourcent).toFixed(decimals).replace('.', ',');
  return `${signe}${corps} %`;
}

/** Variation in points from a decimal delta (0.003 -> "+0,3 pt"). */
export function fmtPoints(deltaDecimal: number, decimals = 1): string {
  const points = deltaDecimal * 100;
  const signe = points >= 0 ? '+' : MINUS;
  const corps = Math.abs(points).toFixed(decimals).replace('.', ',');
  return `${signe}${corps} pt`;
}
